<template>
  <div class="page-outer">
    <div class="preview-wrap">
      <el-tabs v-model="activeCount" @tab-click="handleClick" class="top-tabs">
        <el-tab-pane
          v-for="accountItem of dataList"
          :key="accountItem.accountId"
          :label="`ID：${accountItem.accountId}`"
          :name="accountItem.accountId"
          style="height: 100%"
        >
          <div class="count-area">
            <div v-for="groupItem of accountItem.campaignList" :key="groupItem.createCampaignId" class="group-area">
              <div class="title"><span class="value">广告账号：</span>{{ groupItem.accountId }}</div>
              <div class="title"><span class="value">Campaign名称：</span> {{ groupItem.campaignName }}</div>
              <div class="title">
                <span class="value">Campaign日预算： </span>{{ groupItem.dailyBudget === 0 ? "不限" : groupItem.dailyBudget / 100 }}
              </div>
              <div class="title">
                <span class="value">Campaign总预算：</span> {{ groupItem.totalBudget === 0 ? "不限" : groupItem.totalBudget / 100 }}
              </div>
              <div class="title">
                <span class="value"> Campaign状态： </span>
                <el-switch @change="changeGroupStatus(groupItem)" v-model="groupItem.isOpen"> </el-switch>
              </div>
              <div class="btn-list">
                <el-button
                  @click="changeAdStatus(selectCampaign[groupItem.createCampaignId], false)"
                  type="primary"
                  :disabled="!selectCampaign[groupItem.createCampaignId] || selectCampaign[groupItem.createCampaignId].length === 0"
                  >暂 停
                </el-button>
                <el-button
                  @click="changeAdStatus(selectCampaign[groupItem.createCampaignId], true)"
                  type="primary"
                  :disabled="!selectCampaign[groupItem.createCampaignId] || selectCampaign[groupItem.createCampaignId].length === 0"
                  >开 启
                </el-button>
              </div>
              <div class="table-wrap">
                <el-table :data="groupItem.adSets" style="width: 100%" @selection-change="handleSelectionChange($event, groupItem)">
                  <el-table-column type="selection" width="55"> </el-table-column>
                  <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                      <el-switch @change="changeAdStatus([scope.row], scope.row.isOpen)" v-model="scope.row.isOpen"> </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="广告名称"></el-table-column>
                  <el-table-column label="排期与预算">
                    <template slot-scope="scope">
                      <div class="cell-wrap">
                        <span class="cell-label">开始日期</span>
                        <span class="cell-value">{{ scope.row.startTime }}</span>
                        <span class="cell-label">结束日期</span>
                        <span class="cell-value">{{ scope.row.endTime || "--" }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="版位与出价">
                    <template slot-scope="scope">
                      <div class="cell-wrap">
                        <span class="cell-label">版位名称</span>
                        <span class="cell-value">{{ scope.row.adCreativeTemplateName }}</span>
                        <span class="cell-label">计费方式</span>
                        <span class="cell-value">{{ scope.row.bidMode }}</span>
                        <span class="cell-label">出价</span>
                        <span class="cell-value">{{ scope.row.bidAmount === null ? "自动出价" : scope.row.bidAmount / 100 + "CNY" }} </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="定向">
                    <template slot-scope="scope">
                      <div class="cell-wrap">
                        <span class="cell-label">性别</span>
                        <span class="cell-value">
                          {{
                            !scope.row.targeting.targeting.gender
                              ? "不限"
                              : scope.row.targeting.targeting.gender[0] === "MALE"
                              ? "男"
                              : "女"
                          }}
                        </span>
                        <span class="cell-label">年龄</span>
                        <span class="cell-value">
                          {{
                            !scope.row.targeting.targeting.age || scope.row.targeting.targeting.age.length === 0
                              ? "不限"
                              : `${scope.row.targeting.targeting.age[0].min} - ${scope.row.targeting.targeting.age[0].max}`
                          }}
                        </span>
                        <span class="cell-label">联网方式</span>
                        <span class="cell-value">
                          {{
                            !scope.row.targeting.targeting.networkType || scope.row.targeting.targeting.networkType.length === 0
                              ? "不限制"
                              : scope.row.targeting.targeting.networkType.join(",")
                          }}
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="address" label="创意">
                    <template slot-scope="scope">
                      <div class="cell-wrap">
                        <span class="cell-label">{{ scope.row.ads[0].groupName || "创意组1" }}</span>
                        <span class="cell-value" v-for="(item, index) in scope.row.ads" :key="index">{{ item.name }}</span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottom-btnlist">
      <el-button class="bot-btn" @click="goBack">返回</el-button>
      <el-button class="bot-btn primary" :loading="pushLoading" @click="pushAdvertise">发布广告</el-button>
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import { publish, getAdCountList, getPreviewList, updateStatus } from "@/api/promotion-gdt.js";
export default {
  data() {
    return {
      activeCount: "",
      activeGroup: "",
      dataList: [],
      optionList: [],
      pushLoading: false,
      countList: [],
      selectCampaign: {},
      previewData: {},
    };
  },
  activated() {
    this.initSelect();
  },
  methods: {
    initSelect() {
      getAdCountList({ platType: 2 }).then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
          this.initData();
        }
      });
    },
    handleSelectionChange(val, data) {
      this.$set(this.selectCampaign, data.createCampaignId, val);
    },
    handleClick() {
      let selectCount = this.dataList.find((item) => item.accountId === this.activeCount);
      if (selectCount) {
        this.activeGroup = selectCount.campaignList[0].createCampaignId;
      }
    },
    formatData(data) {
      let dataList = [];
      for (let [accountId, campaignList] of Object.entries(data)) {
        let curAdcount = this.countList.find((item) => item.advertiserId === accountId);
        dataList.push({
          accountId: accountId,
          accountName: curAdcount.company || "-",
          campaignList,
        });
      }
      return dataList;
    },
    initData() {
      getPreviewList({ id: this.$route.query.id }).then((res) => {
        this.previewData = res.data;
        if (this.previewData) {
          let showData = this.formatData(this.previewData);
          this.dataList = showData;
          this.activeCount = showData[0].accountId;
          this.activeGroup = showData[0].campaignList[0].createCampaignId;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    changeGroupStatus(data) {
      updateStatus({ ids: data.createCampaignId, isOpen: data.isOpen }).then((res) => {
        if (res.code === "0000") {
          this.initData();
        }
      });
    },
    changeAdStatus(list, flag) {
      updateStatus({ ids: list.map((item) => item.createAdSetId), isOpen: flag }).then((res) => {
        if (res.code === "0000") {
          this.initData();
        }
      });
    },
    pushAdvertise() {
      let idList = [];
      for (const key in this.previewData) {
        this.previewData[key].map((item) => {
          idList.push(item.createCampaignId);
        });
      }
      this.pushLoading = true;
      publish({ campaignIds: idList.join(",") }).then((res) => {
        this.pushLoading = false;
        if (res.code === "0000") {
          this.$message({
            message: "计划发布成功",
            type: "success",
          });
          this.$router.replace("/promotion.html");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page-outer {
  height: calc(100% - 132px);
  .preview-wrap {
    margin: 16px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    margin-bottom: 120px;
    height: 100%;
    .top-tabs {
      height: 100%;
      /deep/ .el-tabs__nav {
        margin-left: 24px;
      }
      /deep/ .el-tabs__content {
        height: 100%;
      }
      /deep/ .el-tab-pane {
        height: calc(100% - 54px) !important;
        overflow: auto;
      }
    }
    .group-tabs {
      /deep/ .el-tabs__nav {
        margin-left: 0px;
      }
      /deep/ .el-tabs__header {
        margin: 0px;
      }
      /deep/ .el-tabs__item {
        background-color: rgba(0, 0, 0, 0.02);
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        &.is-active {
          background-color: #fff;
          color: rgba(24, 144, 255, 1);
          font-weight: bold;
        }
      }
    }
    .count-area {
      margin-left: 24px;
      padding-right: 24px;
    }
    .group-area {
      min-height: 400px;
      margin-bottom: 24px;
      border: 1px solid #e4e7ed;
      border-bottom: none;
      .title {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        padding: 6px 20px;
        .value {
          width: 130px;
          display: inline-block;
          text-align: right;
          font-weight: 600;
        }
      }
      .btn-list {
        margin-top: 12px;
        padding-left: 20px;
        .btn {
          // color: rgba(24, 144, 255, 1);
          // font-size: 14px;
          // border-radius: 2px;
          // border: 1px solid rgba(24, 144, 255, 1);
          // background: rgba(255, 255, 255, 1);
          .btn-icon {
            margin-right: 4px;
            color: white;
          }
        }
      }
      .table-wrap {
        margin-top: 16px;
        /deep/ td {
          vertical-align: top;
        }
        .cell-wrap {
          .cell-label {
            display: block;
            color: rgba(0, 0, 0, 0.65);
            font-weight: bold;
            font-size: 14px;
            // margin-top: 6px;
          }
          .cell-value {
            display: block;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            margin-left: 16px;
          }
          .table-cascader {
            line-height: 0px !important;
            /deep/ input {
              border: none;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
              background-color: transparent;
              padding: 0px;
              height: 15px;
            }
            /deep/ .el-input {
              line-height: 15px !important;
            }
            /deep/ .el-input__suffix {
              display: none;
            }
          }
        }
      }
    }
  }
  .bottom-btnlist {
    padding-left: 16px;
    position: fixed;
    bottom: 0px;
    width: 100%;
    text-align: center;
    background: white;
    z-index: 99;
    line-height: 55px;
    .bot-btn {
      height: 40px;
      width: 117px;
      color: rgba(24, 144, 255, 1);
      font-size: 14px;
      border-radius: 2px;
      border: 1px solid rgba(24, 144, 255, 1);
      &.primary {
        color: #fff;
        background: rgba(24, 144, 255, 1);
      }
    }
  }
}
</style>
